import React, { useMemo } from 'react';
import { Pie } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend
} from 'chart.js';

// Register Chart.js components
ChartJS.register(ArcElement, Tooltip, Legend);

const sampleData = {
  datasets: [
    {
      data: [300, 50, 100],
      backgroundColor: ['#FF6384', '#36A2EB', '#FFCE56'],
      hoverBackgroundColor: ['#FF6384', '#36A2EB', '#FFCE56'],
    },
  ],
};

const Chart = React.memo(function Chart({ width = 100, height = 100, options = {}, data = sampleData }) {
  const memoizedData = useMemo(() => data, [data]);
  const memoizedOptions = useMemo(() => ({
    maintainAspectRatio: false,
    ...options,
  }), [options]);

  return (
    <div>
      <Pie
        data={memoizedData}
        width={width}
        height={height}
        legend={{ display: false }}
        options={memoizedOptions}
      />
    </div>
  );
});

export default Chart;
